/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software: you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation, either
 * version 3 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with OrangeHRM.
 * If not, see <https://www.gnu.org/licenses/>.
 */

// Country calling codes (ITU E.164). +1 and +7 are shared, so they name both.
// ponytail: country level only; +1's area codes (US vs Canada vs Caribbean) aren't told apart
const CODES = {
  1: 'USA / Canada',
  7: 'Russia / Kazakhstan',
  20: 'Egypt',
  27: 'South Africa',
  30: 'Greece',
  31: 'Netherlands',
  32: 'Belgium',
  33: 'France',
  34: 'Spain',
  36: 'Hungary',
  39: 'Italy',
  40: 'Romania',
  41: 'Switzerland',
  43: 'Austria',
  44: 'United Kingdom',
  45: 'Denmark',
  46: 'Sweden',
  47: 'Norway',
  48: 'Poland',
  49: 'Germany',
  51: 'Peru',
  52: 'Mexico',
  53: 'Cuba',
  54: 'Argentina',
  55: 'Brazil',
  56: 'Chile',
  57: 'Colombia',
  58: 'Venezuela',
  60: 'Malaysia',
  61: 'Australia',
  62: 'Indonesia',
  63: 'Philippines',
  64: 'New Zealand',
  65: 'Singapore',
  66: 'Thailand',
  81: 'Japan',
  82: 'South Korea',
  84: 'Vietnam',
  86: 'China',
  90: 'Turkey',
  91: 'India',
  92: 'Pakistan',
  93: 'Afghanistan',
  94: 'Sri Lanka',
  95: 'Myanmar',
  98: 'Iran',
  211: 'South Sudan',
  212: 'Morocco',
  213: 'Algeria',
  216: 'Tunisia',
  218: 'Libya',
  220: 'Gambia',
  221: 'Senegal',
  233: 'Ghana',
  234: 'Nigeria',
  237: 'Cameroon',
  244: 'Angola',
  249: 'Sudan',
  250: 'Rwanda',
  251: 'Ethiopia',
  252: 'Somalia',
  254: 'Kenya',
  255: 'Tanzania',
  256: 'Uganda',
  260: 'Zambia',
  263: 'Zimbabwe',
  351: 'Portugal',
  352: 'Luxembourg',
  353: 'Ireland',
  354: 'Iceland',
  355: 'Albania',
  356: 'Malta',
  357: 'Cyprus',
  358: 'Finland',
  359: 'Bulgaria',
  370: 'Lithuania',
  371: 'Latvia',
  372: 'Estonia',
  373: 'Moldova',
  374: 'Armenia',
  375: 'Belarus',
  376: 'Andorra',
  377: 'Monaco',
  378: 'San Marino',
  380: 'Ukraine',
  381: 'Serbia',
  382: 'Montenegro',
  383: 'Kosovo',
  385: 'Croatia',
  386: 'Slovenia',
  387: 'Bosnia and Herzegovina',
  389: 'North Macedonia',
  420: 'Czech Republic',
  421: 'Slovakia',
  423: 'Liechtenstein',
  502: 'Guatemala',
  503: 'El Salvador',
  504: 'Honduras',
  505: 'Nicaragua',
  506: 'Costa Rica',
  507: 'Panama',
  591: 'Bolivia',
  593: 'Ecuador',
  595: 'Paraguay',
  598: 'Uruguay',
  852: 'Hong Kong',
  853: 'Macau',
  855: 'Cambodia',
  856: 'Laos',
  880: 'Bangladesh',
  886: 'Taiwan',
  960: 'Maldives',
  961: 'Lebanon',
  962: 'Jordan',
  963: 'Syria',
  964: 'Iraq',
  965: 'Kuwait',
  966: 'Saudi Arabia',
  967: 'Yemen',
  968: 'Oman',
  970: 'Palestine',
  971: 'United Arab Emirates',
  972: 'Israel',
  973: 'Bahrain',
  974: 'Qatar',
  975: 'Bhutan',
  976: 'Mongolia',
  977: 'Nepal',
  992: 'Tajikistan',
  993: 'Turkmenistan',
  994: 'Azerbaijan',
  995: 'Georgia',
  996: 'Kyrgyzstan',
  998: 'Uzbekistan',
};

/**
 * The phone's country, as "Ukraine (+380)", from its calling code ("+380…" or "00380…");
 * null when the number has no code or an unknown one.
 */
export function phoneCountry(phone) {
  const digits = String(phone || '')
    .trim()
    .replace(/^00/, '+');
  if (!digits.startsWith('+')) return null;
  const number = digits.replace(/\D/g, '');
  for (const length of [3, 2, 1]) {
    const code = number.slice(0, length);
    if (CODES[code]) return `${CODES[code]} (+${code})`;
  }
  return null;
}
